<template> </template>

<script>

export default {
  name: 'RefreshToken',
  data: function() {
    return {};
  },
  mounted: async function() {
    // Refresh TOKEN
    if (this.$auth) {

      // this will signout the user out of the OKTA session and clear the TOKENS locally
      // From documentation this will use the postLogoutRedirectUri to redirect the user to the Homepage
      // we can pass the state to display a message
      try{
        // Set a session Storage var to be used on the implicit callback only when the user was still authenticated - only the TOKEN expired
        // this has to be per tab as multiple tab  could try to rediect to different path...
        if (typeof Storage !== 'undefined') {
            // get the path from the Query
            let pathUri = '/';
            if(this.$route.query.callbackUri !==null || typeof(this.$route.query.callbackUri)!='undefined' )
            {
              pathUri = this.$route.query.callbackUri;
            }
            sessionStorage.setItem('implicitCallbackRedirect', JSON.stringify(pathUri));
        }

          // According to https://github.com/okta/okta-auth-js#tokengetwithredirectoptions
          // we can pass the option prompt none so this will return an error if any issues on OKTA side
          await this.$auth.oktaAuth.token.getWithRedirect({prompt: 'none'});
      }
      catch(ex){
        // Log the error and redirect
        if(this.$logger && typeof(this.$logger)!=='undefined'){
          this.$logger.error('RefreshToken.Vue - Mounted: ', ex)
        }
        this.$router.replace({
          path: '/login',
        });
      }
    } else {
      // just in case $auth is not setup correctly - redirect user to login page
      this.$router.replace({
        path: '/login',
      });
    }
  },
};
</script>

<style lang="scss" scoped></style>
